import { SESSION } from "app/models/custom";

export class DataProviderRequestError {

    //#region Members

    private errorMessage: string

    //#endregion

    //#region Ctor

    public constructor() {
        this.errorMessage = null
    }

    //#endregion

    //#region toString()

    public toString(): string {
        return this.errorMessage
    }

    //#endregion

    //#region Factory

    public static fromSESSION(session: SESSION): DataProviderRequestError {
        if (session != null) {
            const error: DataProviderRequestError = new DataProviderRequestError()

            error.errorMessage = session.toString()

            return error
        }

        return null
    }

    //#endregion
}